import type { JSX, ReactNode } from 'react'

import { PageHeader } from '@buffer-mono/popcorn'

import { SaveViewButton } from '~publish/components/MainSidebar/components/SavedViewsSection'

import styles from './ProductPageTitle.module.css'

export type ProductPageTitleProps = {
  icon: ReactNode
  title: string
  showSaveView?: boolean
}

export const ProductPageTitle = ({
  icon,
  title,
  showSaveView = false,
}: ProductPageTitleProps): JSX.Element => (
  <PageHeader.TitleGroup>
    <PageHeader.TitleLeading>
      <div className={styles.icon}>{icon}</div>
    </PageHeader.TitleLeading>
    <PageHeader.Title>{title}</PageHeader.Title>
    {showSaveView ? (
      <PageHeader.TitleAdornments>
        <SaveViewButton />
      </PageHeader.TitleAdornments>
    ) : null}
  </PageHeader.TitleGroup>
)
